export type PlanText = { description?: string | null; description_i18n?: Record<string, string> | null };

/** Plan description in the UI language, falling back to AZ, then the legacy single-language field. */
export function planDescription(p: PlanText, lang: string): string {
    const code = lang.startsWith("ru") ? "ru" : lang.startsWith("en") ? "en" : "az";
    const m = p.description_i18n || {};
    return (m[code] || m.az || p.description || "").trim();
}
